module.exports = __webpack_public_path__ + "static/proverka-df3c6d88c50497febba203e1862bac45.png";